import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { usePatientHospitallist } from "../../../api/member-management/use-patient-detail";
import Table from "../../../components/ui/Table/Table";
import { indexer } from "../../../utils/utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hospital?.name, {
      header: "병원명",
      cell: (info) => {
        const val = info.getValue();
        return <div className="w-[12rem] mx-auto">{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hospital?.email, {
      header: "대표계정 아이디",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "연동일시",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>{val ? dayjs(val).format("YYYY-MM-DD HH:mm") : "-"}</div>
        );
      },
    }),
  ];
};

export function PatientHospitalTable(props) {
  const { filter, id } = props;
  const { isEmpty, getDataTableProps } = usePatientHospitallist(filter, id);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll || getDataTableProps().total;

  if (isEmpty) {
    return (
      <div className="flex justify-center mt-[60px] text-[#999999] text-center">
        연동된 병원이 없습니다.
      </div>
    );
  }

  return (
    <Table
      hasSave={false}
      hasPageSizeFilter={false}
      hasSort={false}
      columns={columns(currentPage, pageSize, totalData)}
      {...getDataTableProps()}
    />
  );
}
